import angular from 'angular';
import services from '../services';
import utils from '../utils';

const __module__ = 'leiApp.controllers',
  app = angular.module(__module__, [services, utils]),
  { factory, controller, directive, component, filter } = app;

export { app, factory, controller, directive, component, filter, __module__ as default };
